<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
  
<div *ngIf="ListResources && AccessAllowed" class="p-3 flex flex-column flex-auto">
    <h3 style="margin-bottom: -38px" i18n>Resources</h3>

    <div style="text-align: right; margin-bottom: 20px;">

        <p-toggleButton class="p-button-sm p-button-danger p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
        </p-toggleButton>

        <span class="p-input-icon-left ml-auto" style="margin-right:20px; "> 
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Resource Name"/>
        </span>
        
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/resourceedit/0']" i18>
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span i18>Add</span>
        </button>
        &nbsp;
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span i18>Disable</span>
        </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
    <p-table  #resourceTable 
    [value]="ListResources"  [paginator]="true" [rows]="10" 
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
    [rowsPerPageOptions]="[10,25,50]" 
    [globalFilterFields]="['name']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    datakey="resourceID"
    [selectionPageOnly]="true"
    rowGroupMode="subheader"
    groupRowsBy="data.resourcegroupname"
    [reorderableRows]="true"
    (onRowReorder)="onRowReorder($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem"></th>
                <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pSortableColumn="name" width="70%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">Exclusive
                </th>
                <th pSortableColumn="name" width="10%">Capacity
                </th>
                <th width="5%">Show on Daysheet</th>
                <th width="5%"></th>
                <th width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}"  [pReorderableRow]="index">
                <td>
                    <span class="pi pi-bars" pReorderableRowHandle style="cursor: move"></span>
                </td>
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td>{{data.name}}</td>
                <td *ngIf="data.exclusive"><span class="pi pi-check"></span></td>
                <td *ngIf="!data.exclusive"><span class="pi pi-times"></span></td>
                <td>{{data.concurrentUses}}</td>
                <td>
                    <p-toggleButton class="p-button-sm p-button-danger p-component" [(ngModel)]="data.showondaysheet" offIcon="pi pi-times" onIcon="pi pi-check" (click)="toggleShow(data)"></p-toggleButton>
                </td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.resourceId);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.resourceId)" i18>
                    <span class="pi pi-trash" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr>
        </ng-template>
    </p-table>
    </div>
</div>
